import React, { useState}  from 'react';
import LoadingBar from 'react-top-loading-bar'
import './App.css';
import RegisterAsset from './components/RegisterAsset';
import Navbar from './components/Navbar';
import {Route,Routes} from 'react-router-dom';
import Home from './components/Home';
import ShowAsset from './components/ShowAsset';
import ErrorPage from './components/ErrorPage';
import Web3 from 'web3';
import { simpleStorageAbi } from './abi';
import ChangeDetails from './components/ChangeDetails';
import TransferAsset from './components/TransferAsset';
var web3 = window.web3;
let contractAddr,SimpleContract;
if(web3!==undefined){
  web3 = new Web3(web3.currentProvider);
  contractAddr = '0x6C38421D5AdaEceedF5c0d4FCd41167F83BAFc5D';
  SimpleContract = new web3.eth.Contract(simpleStorageAbi, contractAddr);
}
function App() {
  // const handleGet = async (e) => {
  //   e.preventDefault();
  //   const result = await SimpleContract.methods.get().call();
  //   setGetNumber(result);
  //   console.log(result);
  // }
  // const handleSet = async (e) => {
  //   e.preventDefault();    
  //   const accounts = await window.ethereum.enable();
  //   const account = accounts[0];
  //   const gas = await SimpleContract.methods.registerNewAsset(number)
  //                       .estimateGas();
  //   const result = await SimpleContract.methods.set(number).send({
  //     from: account,
  //     gas 
  //   })
  //   console.log(result);
  // }
  const [progress, setProgress] = useState(0)

  return (
    <>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Navbar/>
      <Routes>
      <Route exact path="/" element={<Home/>} />
      <Route exact path="/home" element={<Home/>} />
      <Route path="/register" element= {<RegisterAsset  SimpleContract={SimpleContract} setProgress={setProgress}/>}/>
      <Route path="/show" element={<ShowAsset  SimpleContract={SimpleContract} setProgress={setProgress}/>} />
        
      
      <Route path="/change" element={<ChangeDetails  SimpleContract={SimpleContract} setProgress={setProgress}/>}/>
        
      
      <Route path="/transfer" element={<TransferAsset  SimpleContract={SimpleContract} setProgress={setProgress}/>}/>
      <Route path="*" element={<ErrorPage/>}/>
      </Routes>
    </>  
);
}

export default App;
